export default "__VITE_ASSET__CZBx$C7y__"